module.exports = __webpack_public_path__ + "img/入会后-卡面系统预设@2x.81f09bd8.png";